import { Tooltip, Callout, RadioGroupNew, RadioButtonNew } from "@octopusdeploy/design-system-components";
import { Permission } from "@octopusdeploy/octopus-server-client";
import React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink";
import { isAllowed } from "~/components/PermissionCheck/PermissionCheck";
import { ExpandableFormSection, Note, Summary } from "~/components/form";
type BuiltInWorkerFeatureProps = {
    isEnabled: boolean;
    onChange: (isEnabled: boolean) => void;
};
export function BuiltInWorkerFeature({ isEnabled, onChange }: BuiltInWorkerFeatureProps) {
    const description = "Enable steps to execute on the Octopus Server's built-in worker.";
    const label = "Run steps on Octopus Server";
    const name = "IsBuiltInWorkerEnabled";
    return (<ExpandableFormSection key="IsBuiltInWorkerEnabled" errorKey="IsBuiltInWorkerEnabled" title={label} summary={isEnabled ? Summary.default("Enabled") : Summary.summary("Disabled")} help={description}>
            {isAllowed({ permission: Permission.AdministerSystem }) ? getBuiltInWorkerRadioButtons(isEnabled, onChange, name, description, label) : getPermissionRequiredMessage(isEnabled)}

            <Note>
                <p>
                    This feature enables Azure, AWS, Terraform and some scripts steps to use the
                    <ExternalLink href="BuiltinWorker"> built-in worker</ExternalLink> to run Calamari on the Octopus Server. If the built-in worker is disabled, these steps can't run on the Octopus Server and worker pools should be provisioned to
                    allow these steps to run. Learn more about <ExternalLink href="Worker">workers</ExternalLink>.
                </p>
            </Note>
        </ExpandableFormSection>);
}
function getBuiltInWorkerRadioButtons(isEnabled: boolean, onChange: (isEnabled: boolean) => void, name: string, description: string, title: string): React.ReactNode {
    return (<>
            <RadioGroupNew value={isEnabled} onChange={onChange} label={title} description={description} hideLabel={true} hideDescription={true}>
                <RadioButtonNew value={true} label="Enabled" name={name} hasDefaultMarker={true}/>
                <RadioButtonNew value={false} label="Disabled" name={name}/>
            </RadioGroupNew>

            {!isEnabled && (<Callout title={"Be careful when disabling the built-in worker"} type={"warning"}>
                    <span>Disabling this option may impact existing steps that are configured to run on the built in worker. Deployments containing those steps will fail unless an external worker is provisioned.</span>
                </Callout>)}
        </>);
}
function getPermissionRequiredMessage(isEnabled: boolean): React.ReactNode {
    return (<Tooltip content="This feature can only be modified by the System Administrator" position="left">
            <Callout type={"information"} title={"Permission required"}>
                The {Permission.AdministerSystem} permission is required to {isEnabled} the Built-in Worker.
            </Callout>
        </Tooltip>);
}
